import React from 'react';
import { overlaySelector } from '@root/store/slices/overlaySlice';
import {
  phaserSelector,
  type PhaserSliceState,
} from '@root/store/slices/phaserSlice';
import { roundSelector } from '@root/store/slices/roundSlice';
import { useTypedSelector } from '@root/store/store';
import { useTranslation } from 'react-i18next';
import styles from './PhaserOverlay.module.scss';

const PhaserOverlay: React.FC = () => {
  const { t } = useTranslation();
  const { visible, bettingRemainingTime } = useTypedSelector(overlaySelector);
  const { availableToBet } = useTypedSelector(roundSelector);
  const { sceneReady } = useTypedSelector<PhaserSliceState>(phaserSelector);

  if (sceneReady !== 'Level') return null;

  // `visible` is true while the betting window is closed and the round is
  // still IN_PLAY (i.e. racing, before FINISHED) — the CSS-driven cue for
  // "the roll is locked in, the pawn is moving".
  const showRacing =
    visible && !(availableToBet && Number(bettingRemainingTime) > 0);

  return (
    <div className={styles.root}>
      {showRacing && (
        <div className={styles.racingOverlay}>
          <div className={styles.racingText}>{t('RACING...')}</div>
        </div>
      )}
    </div>
  );
};

export default PhaserOverlay;
